import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./Application";
import store from "./core/store/store";
import { AuthModalProvider } from './core/context';

const root: any = ReactDOM.createRoot(document.getElementById("app") as HTMLElement);
root.render(
  <Provider store={store}>
    <AuthModalProvider>
      <App />
    </AuthModalProvider>
  </Provider>
);
